const translation = {
  toVerifiedTip: {
    end: 'Dify Profesyonel Planı için.',
    front: 'Artık Eğitim Doğrulandı statüsüne uygun oldunuz. Lütfen süreci tamamlamak ve bir almak için eğitim bilgilerinizi aşağıya girin.',
    coupon: 'özel %100 kupon',
  },
  form: {
    schoolName: {
      placeholder: 'Okulunuzun resmi, kısaltılmamış adını girin',
      title: 'Okulunuzun Adı',
    },
    schoolRole: {
      option: {
        student: 'Öğrenci',
        teacher: 'Öğretmen',
        administrator: 'Okul Yöneticisi',
      },
      title: 'Okul Rolünüz',
    },
    terms: {
      desc: {
        front: 'Eğitim Doğrulandı durumunuza ilişkin bilgileriniz ve kullanımınız, bizim',
        termsOfService: 'Hizmet Şartları',
        end: 'Göndererek:',
        privacyPolicy: 'Gizlilik Politikası',
        and: 've',
      },
      option: {
        age: 'En az 18 yaşında olduğumu onaylıyorum.',
        inSchool: 'Verilen kurumda kayıtlı veya istihdamda olduğumu onaylıyorum. Dify, kayıt veya istihdam kanıtı talep edebilir. Uygunluğumu yanlış beyan edersem, eğitim durumuma dayalı olarak başlangıçta feragat edilen her türlü ücreti ödemeyi kabul ediyorum.',
      },
      title: 'Şartlar ve Koşullar',
    },
  },
  toVerified: 'Eğitim Bilgilerinizi Doğrulayın',
  currentSigned: 'ŞU ANDA GİRİŞ YAPILDIĞI KİŞİ',
  submitError: 'Form gönderimi başarısız oldu. Lütfen daha sonra tekrar deneyin.',
  rejectTitle: 'Dify Eğitim Doğrulamanız Rededildi',
  emailLabel: 'Şu anki e-posta adresin',
  submit: 'Gönder',
  rejectContent: 'Maalesef, Eğitim Doğrulama statüsüne uygun değilsiniz ve bu nedenle bu e-posta adresini kullanıyorsanız Dify Profesyonel Planı için özel %100 kuponu alamazsınız.',
  learn: 'Eğitim doğrulamasının nasıl yapılacağını öğrenin',
  successContent: 'Hesabınıza Dify Profesyonel planı için %100 indirim kuponu verdik. Kuponun geçerlilik süresi bir yıldır, lütfen bu süre içinde kullanın.',
  successTitle: 'Dify Eğitim Onayınız Var',
}

export default translation
